import { Icon, TaskHeader } from '@scale/scaleui';
import { FC } from 'react';
import TaskMetadataPopover from '../TaskMetadataPopover';

type InfoTaskIdProps = {
  taskId?: string;
  taskMetadata?: any;
  visible?: boolean;
};

export const InfoTaskId: FC<InfoTaskIdProps> = ({ taskId, taskMetadata, visible }) => {
  if (!taskId) return null;
  return (
    <>
      <TaskHeader.InfoHandlerItem title="TaskID" visible={visible}>
        <div className="break-words flex items-center">
          {taskId}{' '}
          <Icon
            icon={'copy'}
            tooltip="Copy task ID"
            size="sm"
            className="h-5 inline-flex"
            onClick={() => {
              navigator.clipboard.writeText(taskId);
            }}
          />
        </div>
      </TaskHeader.InfoHandlerItem>

      {taskMetadata && <TaskMetadataPopover fromReviewHeader={false} taskMetadata={taskMetadata} />}
    </>
  );
};
